import Repository from '../Repository';
import dateUtils from "@/utils/dateUtils";

export default {

	allocatePaper(userRoleId, paperId) {
		var response = Repository.post('Paper/AllocatePaper', {
			userRoleId: userRoleId,
			paperId: paperId,
		});
		return response;
	},

	allocatePaperBulk(usersPaperAmount, qualificationId, languageId, subjectId, periodId, assessmentCodeIds, tutorCentre, invigilator) {
		var response = Repository.post('Paper/AllocatePaperBulk', {
			usersPaperAmount: usersPaperAmount,
			qualificationId: qualificationId,
			languageId: languageId,
			subjectId: subjectId,
			periodId: periodId,
			assessmentCodeIdsCSV: (assessmentCodeIds == null) ? null : assessmentCodeIds.join(','),
			tutorCentre: tutorCentre,
			invigilator: invigilator
		});
		return response;
	},

	cancelSubmission(paperId) {
		let response = Repository.delete('Paper/CancelSubmission', {
			params: {		
				paperId: paperId
			}
		});
		return response;		
	},

	deallocatePaper(paperId) {
		var response = Repository.put('Paper/DeallocatePaper', {
			paperId: paperId,
			proceedWithDeallocation: true
		});
		return response;
	},

	deallocatePaperBulk(paperIds) {
		var response = Repository.put('Paper/DeallocatePaperBulk', {
			paperIdsCSV: (paperIds == null) ? null : paperIds.join(','),
		});
		return response;
	},

	downloadOriginalPaper(paperId) {

		var response = Repository.get('Paper/DownloadOriginalPaper', {
			responseType: 'arraybuffer',
            headers: {
				'Content-Type': 'application/json',
				'Accept': 'application/pdf'
            },					
			params: {
				paperId: paperId
			}
		});
		return response;
	},

	getAllPaperStatuses() {
		var response = Repository.get('Paper/GetAllPaperStatuses', {});
		return response;
	},

	getMarkerPaperAllocations(pageSize, pageNumber, searchString) {
		var response = Repository.get('Paper/GetMarkerPaperAllocations', {
			params: {
				pageSize: pageSize,
				pageNumber: pageNumber,	
				searchString: searchString		
			}			
		});
		return response;
	},

	getFilteredMarkerPaperAllocations({ pageSize, pageNumber, searchString, language, qualificationCode, taskNumber, assessmentType, subjectCode }) {
		return Repository.get('Paper/GetMarkerPaperAllocations', {
			params: {
				pageSize,
				pageNumber,
				searchString,
				language: language,
				qualificationCode: qualificationCode,
				taskNumber: taskNumber,
				assessmentType: assessmentType,
				subjectCode: subjectCode
			}
		});
	},	

	getPaper(paperId) {
		var response = Repository.get('Paper/GetPaper', {
			params: {
				paperId: paperId
			}			
		});
		return response;
	},

	getPaperAuditLogs(pageSize, pageNumber, searchString, searchPaperId, paperStatusIds) {
		let payLoad = {params: {}};
		if(paperStatusIds != null)
			payLoad.params = {
				pageSize: pageSize,
				pageNumber: pageNumber,
				SearchString: searchString,
				isActive: true,
				orderDirection: 'desc',
				SortBy: 'createTime',
				SearchPaperId: searchPaperId,
				PaperStatusIdCSV: (paperStatusIds == null) ? null : paperStatusIds.join(','),
			}
		else
			payLoad.params = { 
				pageSize: pageSize,
				pageNumber: pageNumber,
				SearchString: searchString,
				isActive: true,
				orderDirection: 'desc',
				SortBy: 'createTime', 
			}
		let response = Repository.get('Paper/getPaperLogs', payLoad);
		return response;
	},

	getPapers(pageSize, pageNumber, studentSearchString, markerSearchString, userRoleIds, periodIds, 
		subPeriodIds, qualificationIds, subjectIds, assessmentTypeIds, assessmentCodeIds, paperStatusIds, 
		markingTypeIds, olderThanDays, youngerThanDays, statusChangeDate, uploadDate, pendingPayment, 
		isActive, batched, tutorCentres, invigilators) {

		let statusChangeRange = {
			timeStart: null,
			timeEnd: null
		};
		if (statusChangeDate != null) {
			statusChangeRange = dateUtils.dateToUnixUTCDayRange(statusChangeDate);
		}

		let uploadRange = {
			timeStart: null,
			timeEnd: null
		};
		if (uploadDate != null) {
			uploadRange = dateUtils.dateToUnixUTCDayRange(uploadDate);
		}		

		var response = Repository.get('Paper/GetPapers', {
			params: {
				pageSize: pageSize,
				pageNumber: pageNumber,				
				studentSearchString: studentSearchString,
				markerSearchString: markerSearchString,
				RoleIdCSV: (userRoleIds == null) ? null : userRoleIds.join(','),
				PeriodIdCSV: (periodIds == null) ? null : periodIds.join(','),
				SubPeriodIdCSV: (subPeriodIds == null) ? null : subPeriodIds.join(','),
				QualificationIdCSV: (qualificationIds == null) ? null : qualificationIds.join(','),
				SubjectIdCSV: (subjectIds == null) ? null : subjectIds.join(','),
				AssessmentTypeIdCSV: (assessmentTypeIds == null) ? null : assessmentTypeIds.join(','),
				AssessmentCodeIdCSV: (assessmentCodeIds == null) ? null : assessmentCodeIds.join(','),
				PaperStatusIdCSV: (paperStatusIds == null) ? null : paperStatusIds.join(','),
				MarkingTypeIdCsv: (markingTypeIds == null) ? null : markingTypeIds.join(','),
				OlderThanDays: (olderThanDays <= 0) ? null : olderThanDays,
				YoungerThanDays: (youngerThanDays <= 0) ? null : youngerThanDays,
				StatusChangeDateStart: statusChangeRange.startTime,
				StatusChangeDateEnd: statusChangeRange.endTime,
				UploadDateStart: uploadRange.startTime,
				UploadDateEnd: uploadRange.endTime,
				pendingPayment: pendingPayment,
				batched: batched,
				orderDirection: 'desc',
				isActive: isActive,
				tutorCentreCSV: (tutorCentres == null) ? null : tutorCentres.join(','),
				invigilatorCSV: (invigilators == null) ? null : invigilators.join(','),
			}
		});
		return response;
	},
	
	getPapersCsv(studentSearchString, markerSearchString, userRoleIds, periodIds, subPeriodIds, 
		qualificationIds, subjectIds, assessmentTypeIds, assessmentCodeIds, paperStatusIds, markingTypeIds, 
		olderThanDays, youngerThanDays, statusChangeDate, uploadDate, tutorCentres, invigilators) {

		let statusChangeRange = {
			timeStart: null,
			timeEnd: null
		};
		if (statusChangeDate != null) {
			statusChangeRange = dateUtils.dateToUnixUTCDayRange(statusChangeDate);
		}

		let uploadRange = {
			timeStart: null,
			timeEnd: null
		};
		if (uploadDate != null) {
			uploadRange = dateUtils.dateToUnixUTCDayRange(uploadDate);
		}		

		var response = Repository.get('Paper/GetPapersCsv', {
			responseType: 'arraybuffer',
            headers: {
                'Content-Type': 'application/csv',
                'Accept': 'application/csv'
            },					
			params: {
				studentSearchString: studentSearchString,
				markerSearchString: markerSearchString,
				RoleIdCSV: (userRoleIds == null) ? null : userRoleIds.join(','),
				PeriodIdCSV: (periodIds == null) ? null : periodIds.join(','),
				SubPeriodIdCSV: (subPeriodIds == null) ? null : subPeriodIds.join(','),
				QualificationIdCSV: (qualificationIds == null) ? null : qualificationIds.join(','),
				SubjectIdCSV: (subjectIds == null) ? null : subjectIds.join(','),
				AssessmentTypeIdCSV: (assessmentTypeIds == null) ? null : assessmentTypeIds.join(','),
				AssessmentCodeIdCSV: (assessmentCodeIds == null) ? null : assessmentCodeIds.join(','),
				PaperStatusIdCSV: (paperStatusIds == null) ? null : paperStatusIds.join(','),
				MarkingTypeIdCSV: (markingTypeIds == null) ? null : markingTypeIds.join(','),
				OlderThanDays: (olderThanDays <= 0) ? null : olderThanDays,
				YoungerThanDays: (youngerThanDays <= 0) ? null : youngerThanDays,
				StatusChangeDateStart: statusChangeRange.startTime,
				StatusChangeDateEnd: statusChangeRange.endTime,
				UploadDateStart: uploadRange.startTime,
				UploadDateEnd: uploadRange.endTime,
				tutorCentreCSV: (tutorCentres == null) ? null : tutorCentres.join(','),
				invigilatorCSV: (invigilators == null) ? null : invigilators.join(','),				
				Csv: true	
			}
		});
		return response;
	},

	getPaperPayments(pageSize, pageNumber, studentSearchString, markerSearchString, batchCodeSearchString, vendorCodeSearchString, userRoleIds, periodIds, 
		subPeriodIds, qualificationIds, subjectIds, assessmentTypeIds, assessmentCodeIds, 
		markingTypeIds, olderThanDays, youngerThanDays, statusChangeDate, uploadDate, 
		isActive, batched) {

		let statusChangeRange = {
			timeStart: null,
			timeEnd: null
		};
		if (statusChangeDate != null) {
			statusChangeRange = dateUtils.dateToUnixUTCDayRange(statusChangeDate);
		}

		let uploadRange = {
			timeStart: null,
			timeEnd: null
		};
		if (uploadDate != null) {
			uploadRange = dateUtils.dateToUnixUTCDayRange(uploadDate);
		}		

		var response = Repository.get('Paper/GetPaperPayments', {
			params: {
				pageSize: pageSize,
				pageNumber: pageNumber,				
				studentSearchString: studentSearchString,
				markerSearchString: markerSearchString,
				batchCodeSearchString: batchCodeSearchString, 
				vendorCodeSearchString: vendorCodeSearchString,
				RoleIdCSV: (userRoleIds == null) ? null : userRoleIds.join(','),
				PeriodIdCSV: (periodIds == null) ? null : periodIds.join(','),
				SubPeriodIdCSV: (subPeriodIds == null) ? null : subPeriodIds.join(','),
				QualificationIdCSV: (qualificationIds == null) ? null : qualificationIds.join(','),
				SubjectIdCSV: (subjectIds == null) ? null : subjectIds.join(','),
				AssessmentTypeIdCSV: (assessmentTypeIds == null) ? null : assessmentTypeIds.join(','),
				AssessmentCodeIdCSV: (assessmentCodeIds == null) ? null : assessmentCodeIds.join(','),
				MarkingTypeIdCsv: (markingTypeIds == null) ? null : markingTypeIds.join(','),
				OlderThanDays: (olderThanDays <= 0) ? null : olderThanDays,
				YoungerThanDays: (youngerThanDays <= 0) ? null : youngerThanDays,
				StatusChangeDateStart: statusChangeRange.startTime,
				StatusChangeDateEnd: statusChangeRange.endTime,
				UploadDateStart: uploadRange.startTime,
				UploadDateEnd: uploadRange.endTime,
				batched: batched,
				orderDirection: 'desc',
				isActive: isActive
			}
		});
		return response;
	},

	getRecentlyMarkedPapers(pageSize, pageNumber) {

		var response = Repository.get('Paper/GetRecentlyMarkedPapers', {
			params: {
				pageSize: pageSize,
				pageNumber: pageNumber,
				orderDirection: 'desc',
				SortBy: 'DateMarked'
			}
		});
		return response;
	},

	getUnbatchedReceivedManualComponents(pageSize, pageNumber, studentSearchString, markerSearchString, paperRoleIds, periodIds, 
		subPeriodIds, qualificationIds, subjectIds, languageIds, assessmentTypeIds, assessmentCodeIds, paperStatusIds, olderThanDays, youngerThanDays, statusChangeDate, uploadDate, pendingPayment, 
		isActive) {

		let statusChangeRange = {
			timeStart: null,
			timeEnd: null
		};
		if (statusChangeDate != null) {
			statusChangeRange = dateUtils.dateToUnixUTCDayRange(statusChangeDate);
		}

		let uploadRange = {
			timeStart: null,
			timeEnd: null
		};
		if (uploadDate != null) {
			uploadRange = dateUtils.dateToUnixUTCDayRange(uploadDate);
		}		

		var response = Repository.get('Paper/GetUnbatchedReceivedManualComponents', {
			params: {
				pageSize: pageSize,
				pageNumber: pageNumber,				
				studentSearchString: studentSearchString,
				markerSearchString: markerSearchString,
				PaperRoleIdCSV: (paperRoleIds == null) ? null : paperRoleIds.join(','),
				PeriodIdCSV: (periodIds == null) ? null : periodIds.join(','),
				SubPeriodIdCSV: (subPeriodIds == null) ? null : subPeriodIds.join(','),
				QualificationIdCSV: (qualificationIds == null) ? null : qualificationIds.join(','),
				SubjectIdCSV: (subjectIds == null) ? null : subjectIds.join(','),
				LanguageIdCSV: (languageIds == null) ? null : languageIds.join(','),
				AssessmentTypeIdCSV: (assessmentTypeIds == null) ? null : assessmentTypeIds.join(','),
				AssessmentCodeIdCSV: (assessmentCodeIds == null) ? null : assessmentCodeIds.join(','),
				PaperStatusIdCSV: (paperStatusIds == null) ? null : paperStatusIds.join(','),
				OlderThanDays: (olderThanDays <= 0) ? null : olderThanDays,
				YoungerThanDays: (youngerThanDays <= 0) ? null : youngerThanDays,
				StatusChangeDateStart: statusChangeRange.startTime,
				StatusChangeDateEnd: statusChangeRange.endTime,
				UploadDateStart: uploadRange.startTime,
				UploadDateEnd: uploadRange.endTime,
				pendingPayment: pendingPayment,
				orderDirection: 'desc',
				isActive: isActive
			}
		});
		return response;
	},

	issueAssessmentRemark(assessmentId, proceedWithRemark) {
		var response;
		response = Repository.put('Paper/IssuePaperRemark', {
			assessmentId: assessmentId,
			proceedWithRemark: proceedWithRemark
		});
		return response;
	},

	issuePaperRemark(paperId) {
		var response;
		response = Repository.put('Paper/IssuePaperRemark', {
			paperId: paperId,
			proceedWithRemark: true
		});
		return response;
	},

	getTutorCentres(qualificationId, languageId, subjectId, assessmentTypeId, assessmentCodeIds, periodId, roleIds) {
		var response = Repository.get('Paper/GetTutorCentres', {
			params: {
				qualificationIdCSV: (qualificationId > 0) ? qualificationId : '',
				languageIdCSV: (languageId > 0) ? languageId : '',
				subjectIdCSV: (subjectId > 0) ? subjectId : '',
				assessmentTypeIdCSV: (assessmentTypeId > 0) ? assessmentTypeId : '',
				assessmentCodeIdCSV: (assessmentCodeIds == null) ? null : assessmentCodeIds.join(','),
				periodIdCSV: (periodId > 0) ? periodId : '',
				roleIDCSV: (roleIds == null) ? null : roleIds.join(','),				
			}
		});
		return response;
	},

	getInvigilators(qualificationId, languageId, subjectId, assessmentTypeId, assessmentCodeIds, periodId, roleIds) {
		var response = Repository.get('Paper/GetInvigilators', {
			params: {
				qualificationIdCSV: (qualificationId > 0) ? qualificationId : '',
				languageIdCSV: (languageId > 0) ? languageId : '',
				subjectIdCSV: (subjectId > 0) ? subjectId : '',
				assessmentTypeIdCSV: (assessmentTypeId > 0) ? assessmentTypeId : '',
				assessmentCodeIdCSV: (assessmentCodeIds == null) ? null : assessmentCodeIds.join(','),
				periodIdCSV: (periodId > 0) ? periodId : '',
				roleIDCSV: (roleIds == null) ? null : roleIds.join(','),				
			}
		});
		return response;
	},

	getAllTutorCentres() {
		var response = Repository.get('Paper/GetAllTutorCentres', {
			params: {		
			}
		});
		return response;
	},

	getAllInvigilators() {
		var response = Repository.get('Paper/GetAllInvigilators', {
			params: {		
			}
		});
		return response;
	},

}
